(ns frontend.view.grid.oppos-grid.events
  (:require
   [clojure.string :as string]
   [common.country :as country]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.entity-types :as entity-types]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.named-view :as named-view-actions]
   [frontend.conn :as conn]
   [frontend.exports.excel :as excel]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [frontend.view.grid.companies-grid.events :as companies-events]
   [frontend.view.grid.fof-assets-grid.events :as fof-assets-events]
   [frontend.view.grid.oppos-grid.columns :as columns]
   [frontend.view.grid.oppos-grid.db :as db]
   [frontend.view.grid.other-assets-grid.events :as other-assets-events]
   [frontend.view.grid.real-estates-grid.events :as real-estates-events]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [potpuri.core :refer [fn->]]
   [promesa.core :as p]
   [reagent.core :as r]))


(defn alj-system-views
  []
  [{:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value #{:oppo.status/ok}}}
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :active-pipeline)
    :disable-delete? true
    :db/id "named-view-active-pipeline"}
   {:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :all-deals)
    :disable-delete? true
    :db/id "named-view-all-deals"}
   {:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"
                          :filters          {:oppo/owner {:operand :operand/any-of
                                                          :lower-bound-value
                                                          #{(:db/id @session/account)}}}}
    :named-view/name (loc/tr :my-deals)
    :disable-delete? true
    :db/id "named-view-my-deals"}
   {:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value
                                                           #{:oppo.status/passed}}}
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :passed-cases)
    :disable-delete? true
    :db/id "named-view-passed-deals"}
   {:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value
                                                           #{:oppo.status/on-hold}}}
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :deals-on-hold)
    :disable-delete? true
    :db/id "named-view-deals-on-hold"}
   {:named-view/settings {:selected-columns (set columns/default-alj-columns)
                          :ordered-columns  columns/default-alj-columns
                          :view-mode        :board-mode
                          :filters          {:common/created-on {:operand :operand/on-or-after
                                                                 :lower-bound-value
                                                                 (fu/millis-start-of-this-q)}}
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :new-deals-this-q)
    :disable-delete? true
    :db/id "named-view-new-deals-this-q"}])


(defn default-system-views
  []
  [{:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :board-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value #{:oppo.status/ok}}}
                          :sort-by          :common/updated-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :active-pipeline)
    :disable-delete? true
    :db/id "named-view-active-pipeline"}
   {:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :grid-mode
                          :sort-by          :oppo/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :all-deals)
    :disable-delete? true
    :db/id "named-view-all-deals"}
   {:named-view/settings {:selected-columns columns/my-deals-columns
                          :ordered-columns  columns/my-deals-ordered-columns
                          :view-mode        :grid-mode
                          :sort-by          :common/updated-on
                          :sort-direction   "DESC"
                          :filters          {:oppo/owner {:operand :operand/any-of
                                                          :lower-bound-value
                                                          #{(:db/id @session/account)}}}}
    :named-view/name (loc/tr :my-deals)
    :disable-delete? true
    :db/id "named-view-my-deals"}
   {:named-view/settings {:selected-columns columns/passed-deals-columns
                          :ordered-columns  columns/passed-deals-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value
                                                           #{:oppo.status/passed}}}
                          :sort-by          :oppo/passed-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :passed-cases)
    :disable-delete? true
    :db/id "named-view-passed-deals"}
   {:named-view/settings {:selected-columns columns/deals-on-hold-columns
                          :ordered-columns  columns/deals-on-hold-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:oppo/status {:operand :operand/any-of
                                                           :lower-bound-value
                                                           #{:oppo.status/on-hold}}}
                          :sort-by          :oppo/put-on-hold-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :deals-on-hold)
    :disable-delete? true
    :db/id "named-view-deals-on-hold"}
   {:named-view/settings {:selected-columns columns/new-deals-this-q-columns
                          :ordered-columns  columns/new-deals-this-q-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:common/created-on {:operand :operand/on-or-after
                                                                 :lower-bound-value
                                                                 (fu/millis-start-of-this-q)}}
                          :sort-by          :common/created-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :new-deals-this-q)
    :disable-delete? true
    :db/id "named-view-new-deals-this-q"}])

(defn system-views
  []
  (cond (tenant-customizations/alj?)
        (alj-system-views)
        :else
        (default-system-views)))

(defn system-views-by-id
  []
  (->> (system-views)
       (map (fn [v]
              [(:db/id v) v]))
       (into {})))

(defn named-views
  []
  (concat (system-views)
          (->> @session/all-named-views
               (cu/only-entity :named-view/view :oppos-grid)
               (sort-by :common/created-on))))

(defn named-view-by-id
  [id]
  (or (get @session/entities id)
      (get (system-views-by-id) id)))

(defn ls-path
  [& rest]
  (concat
   [(:db/id @session/account)
    (:db/id @session/tenant)
    :deals-view-settings]
   rest))

(declare setup-column-state!)

(defn load-view!
  [named-view] ;;named-view entity
  (let [{:keys [named-view/settings]} named-view]
    (ls/set-in (ls-path) settings)
    (setup-column-state! settings)))

(defn save-current-view!
  [name]
  (let [settings @db/view-settings
        msg {:named-view/name     name
             :named-view/view     :oppos-grid
             :named-view/settings settings}]
    (named-view-actions/*create-named-view->
     msg
     identity
     (fn [& a] ;;TODO show error message
       (logging/error "create-named-view failed" a)))))

(defn age-in-days-active
  [deal]
  (let [server-time @db/server-time
        date-val (when (= (:oppo/status deal) :oppo.status/ok)
                   (when-let [created (:common/created-on deal)]
                     (fu/millis->days (- server-time created))))]
    date-val))

(defn age-in-days-on-hold
  [deal]
  (let [server-time @db/server-time
        date-val (when (= (:oppo/status deal) :oppo.status/on-hold)
                   (when-let [on-hold-on (:oppo/put-on-hold-on deal)]
                     (fu/millis->days (- server-time on-hold-on))))]
    date-val))

(defn throughput-in-weeks-passed
  [deal]
  (let [date-val (when (= (:oppo/status deal) :oppo.status/passed)
                   (when-let [created (:common/created-on deal)]
                     (when-let [passed-on (:oppo/passed-on deal)]
                       (fu/millis->weeks (- passed-on created)))))]
    date-val))

(defn throughput-in-weeks-invested
  [deal]
  (let [date-val (when (= (:oppo/status deal) :oppo.status/portfolio)
                   (when-let [created (:common/created-on deal)]
                     (when-let [portfolio-on (:oppo/moved-to-portfolio-on deal)]
                       (fu/millis->weeks (- portfolio-on created)))))]
    date-val))

(defn precalculated-schema
  [recalculate?]
  (let [calculated @db/schema
        pipeline (->> @session/selected-oppo-pipeline
                      (get @session/entities))
        schema
        (cond
          (and (not recalculate?)
               calculated)
          calculated
          :else
          (->>
            (registry/get-schema @session/tenant-schema :entity.type/oppo)
            (remove
             (fn [[k v]]
               (let [grid-visibility (->> v
                                          :field/default-visibility
                                          :grid)
                     not-available?
                     (or (columns/not-available k)
                         (nil? grid-visibility)
                         (= grid-visibility :editor.type/none)
                         (if (or (not= (:field/data-type v) :data.type/currency-symbol)
                                 (not (:field/secondary-field? v)))
                           (not (f-permissions/field-read-access? k :entity.type/oppo pipeline))
                           (not (f-permissions/field-read-access? (:field/related-fields v)
                                                                  :entity.type/oppo
                                                                  pipeline))))]
                 not-available?)))
            (sort-by (fn [[_k v]]
                       (-> v
                           :field/translations
                           :en)))))
        asset-types (session/oppo-target-asset-types)
        allowed-asset-types (set asset-types)
        asset-type-schema
        (fn [entity-type]
          (when (and (some #{entity-type} allowed-asset-types)
                     (or recalculate?
                         (not calculated)))
            (->> (case entity-type
                   :entity.type/company
                   (companies-events/precalculated-schema recalculate?)
                   :entity.type/real-estate
                   (real-estates-events/precalculated-schema recalculate?)
                   :entity.type/fof-asset
                   (fof-assets-events/precalculated-schema recalculate?)
                   :entity.type/other-asset
                   (other-assets-events/precalculated-schema recalculate?)
                   nil)
                 ;;remove fields that are inactive in this pipeline)
                 (remove (fn [[k v]]
                           (if (not= (:field/data-type v) :data.type/currency-symbol)
                             (not (f-permissions/field-read-access? k
                                                                    entity-type
                                                                    pipeline))
                             (not (f-permissions/field-read-access? (:field/related-fields v)
                                                                    entity-type
                                                                    pipeline))))))))
        asset-schema (->> asset-types
                          (mapcat asset-type-schema)
                          (map (fn [[k v]]
                                 [[:oppo/target-asset k] v]))
                          (into {})
                          (remove (fn-> first (= [:oppo/target-asset :asset/name])))
                          (sort-by (fn [[_ v]]
                                     (-> v
                                         :field/translations
                                         :en)))
                          doall)

        legal-entity-type-schema
        (fn [entity-type]
          (when (and (some #{entity-type} allowed-asset-types)
                     (or recalculate?
                         (not calculated)))
            (->> (case entity-type
                   :entity.type/fof-asset
                   (companies-events/precalculated-schema recalculate?)
                   nil)
                 ;;remove fields that are inactive in this pipeline)
                 (remove (fn [[k v]]
                           (if (not= (:field/data-type v) :data.type/currency-symbol)
                             (not (f-permissions/field-read-access? k
                                                                    entity-type
                                                                    pipeline))
                             (not (f-permissions/field-read-access? (:field/related-fields v)
                                                                    entity-type
                                                                    pipeline))))))))
        legal-entity-schema (->> asset-types
                                 (mapcat legal-entity-type-schema)
                                 (map (fn [[k v]]
                                        [[:oppo/target-asset :fof-asset/gp k] v]))
                                 (into {})
                                 (remove (fn-> first (= [:oppo/target-asset :fof-asset/gp :asset/name])))
                                 (sort-by (fn [[_ v]]
                                            (-> v
                                                :field/translations
                                                :en)))
                                 (doall))

        schema (if (and (not recalculate?)
                        calculated)
                 schema
                 (concat schema asset-schema legal-entity-schema))]
    (when (or recalculate?
              (not calculated))
      (reset! db/schema schema))
    schema))

;;precalculate for performance reasons
(defn keys-and-schemas
  []
  (precalculated-schema false))

(defn deal-column-keys
  []
  (concat
   (when (session/is-admin?) [:db/id])
   (map first (keys-and-schemas))))

(defn default-kanban-attributes
  []
  (cond
    (tenant-customizations/alj-is-pmo-pipeline? @session/selected-oppo-pipeline)
    columns/alj-pmo-pipeline-kanban-fields
    (tenant-customizations/alj?) columns/alj-kanban-fields
    :else [:oppo/cur-ticket :oppo/status-and-next-steps :oppo/deal-description]))

(defn visible-keys-and-schemas
  []
  (let [{:keys [attributes footer-1 footer-2]} @db/card-settings
        visible-attributes (set (concat @db/selected-columns
                                        attributes
                                        (default-kanban-attributes)
                                        [footer-1 footer-2
                                         (entity-types/type->owner-attribute :entity.type/oppo)]))]
    (->> (keys-and-schemas)
         (filter (fn [[k _fs]]
                   (some #{k} visible-attributes))))))

(declare expanded? toggle-expand!)

(defn column-tabs
  []
  (let [target-asset-types (session/oppo-target-asset-types)]

    (->> (concat [:entity.type/oppo]
                 (when (> (count target-asset-types) 1)
                   [:entity.type/asset])
                 (when (and (= (count target-asset-types) 1)
                            (= (first target-asset-types) :entity.type/fof-asset))
                   [:entity.type/company])
                 target-asset-types)
         (map (fn [entity-type]
                (let [entity-type-name (-> entity-type-names/entities
                                           (get entity-type)
                                           :field/translations
                                           :en)]
                  {:key   entity-type
                   :label (loc/tr :entity-type-fields [entity-type-name])}))))))

(defn resolve-tab
  [field]
  (let [target-asset-types (session/oppo-target-asset-types)
        ref-field? (and (vector? field)
                        (keyword? (first field))
                        (keyword? (second field)))
        [_ref attr] (when ref-field?
                      field)
        fund-gp? (and (vector? field)
                      (= :oppo/target-asset (first field))
                      (= :fof-asset/gp (second field))
                      (keyword? (last field)))]
    (cond
      (keyword? field)
      :entity.type/oppo
      (and fund-gp?
           (= (count target-asset-types) 1))
      :entity.type/company
      (and ref-field?
           (= (count target-asset-types) 1))
      (first target-asset-types)
      (and ref-field?
           (= (namespace attr) "asset"))
      :entity.type/asset
      (and ref-field?
           (= (namespace attr) "common"))
      :entity.type/asset
      (and ref-field?
           (= (namespace attr) "company"))
      :entity.type/company
      (and ref-field?
           (= (namespace attr) "real-estate"))
      :entity.type/real-estate
      (and ref-field?
           (= (namespace attr) "fof-asset"))
      :entity.type/fof-asset
      (and ref-field?
           (= (namespace attr) "other-asset"))
      :entity.type/other-asset
      :else :unknown)))

;;necessary arguments to use common grid functions
(defn setup-args
  []
  {:state                 db/deals
   :entity-type           :entity.type/oppo
   :modal-state db/modal-state
   :selected-columns-state db/selected-columns
   :ordered-columns-state db/ordered-columns
   :filters-state         db/deal-filters
   :view-settings-state   db/view-settings
   :column-widths-state   db/column-widths
   :selected-pipeline     @session/selected-oppo-pipeline
   :containing-entity     (->> @session/selected-oppo-pipeline
                               (get @session/entities))
   :ls-path               ls-path
   :kanban-args           {:default-grouped-by  :oppo/stage
                           :kanban-state        db/kanban
                           :grouped-by-state    db/grouped-by
                           :card-settings-state db/card-settings
                           ;;for long card view:
                           :default-attributes  (default-kanban-attributes)
                           :expanded-state      db/expanded
                           :sorted-kanban-entities-state db/sorted-kanban-entities
                           :lists-state         db/lists
                           :expanded?           expanded?
                           :toggle-expand!      toggle-expand!}
   :kanban?               true
   :column-keys           deal-column-keys
   :column-tabs           (column-tabs)
   ;;note: cannot be an anonymous function - would cause constant re-rendering:
   :resolve-tab           resolve-tab
   :default-columns       columns/default-columns
   :mandatory?            columns/mandatory?
   :visible-keys-and-schemas-fn visible-keys-and-schemas
   :custom-filters        {:oppo/pipeline {:operand :operand/all-of
                                           :lower-bound-value #{@session/selected-oppo-pipeline}}}})

(defn resolve-column-key-universe
  []
  (grid/resolve-column-key-universe (setup-args)))

(defn resolve-column-keys
  []
  (grid/resolve-column-keys (setup-args)))

(defn cleanup
  []
  (when-let [tracker (:tracker-1 @db/deals)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-2 @db/deals)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-3 @db/deals)]
    (r/dispose! tracker))

  ;; TODO - can we dispose global defonce cursors like this ?
  ;; -> use component local state or re-frame instead
  (swap! db/deals dissoc
    :loaded
    :schema
    :entities
    :entity-types
    :view-settings
    :sorted-grid-entities
    :sorted-kanban-entities
    :search
    :kanban
    :selected
    :grid-entities))

(defn setup-column-state!
  [view-settings]
  (reset! db/view-settings view-settings)
  (when (nil? @db/selected-columns)
    (reset! db/selected-columns columns/default-columns)
    (ls/update-in (ls-path) assoc :selected-columns columns/default-columns))
  (grid/recalculate (assoc (setup-args) :re-sort? true)))

(defn add-calculated-fields
  [deal]
  (merge deal
         (when-let [age-in-days-active (->> deal
                                            age-in-days-active)]
           {:oppo/age-in-days-active age-in-days-active})
         (when-let [age-in-days-on-hold (->> deal
                                             age-in-days-on-hold)]
           {:oppo/age-in-days-on-hold age-in-days-on-hold})
         (when-let [throughput-in-weeks-passed (->> deal
                                                    throughput-in-weeks-passed)]
           {:oppo/throughput-in-weeks-passed throughput-in-weeks-passed})
         (when-let [throughput-in-weeks-invested (->> deal
                                                      throughput-in-weeks-invested)]
           {:oppo/throughput-in-weeks-invested throughput-in-weeks-invested})))

(defn entity-updates
  []
  (let [enriched-oppos (->> @session/all-oppos
                            (cu/filter-by :oppo/pipeline
                                          @session/selected-oppo-pipeline)
                            (map add-calculated-fields))
        target-asset-types (:pipeline/target-asset-types @session/selected-oppo-pipeline-entity)
        companies-trigger (when (some #{:entity.type/company} target-asset-types)
                            @session/all-companies)
        fof-assets-trigger (when (some #{:entity.type/fof-asset} target-asset-types)
                             @session/all-fof-assets)
        real-estate-trigger (when (some #{:entity.type/real-estate} target-asset-types)
                              @session/all-real-estates)
        other-assets-trigger (when (some #{:entity.type/other-asset} target-asset-types)
                               @session/all-other-assets)]
    (when (or companies-trigger
              fof-assets-trigger
              real-estate-trigger
              other-assets-trigger
              enriched-oppos)
      (swap! db/deals assoc :grid-entities enriched-oppos)
      (deref db/deals))))

(defn permission-updates
  []
  (let [current-permissions @session/current-permissions]
    (when current-permissions
      (precalculated-schema true))))

(defn trigger-recalculation
  []
  (let [permissions-trigger @db/schema
        entities-trigger @db/grid-entities]
    (when (or permissions-trigger entities-trigger)
      (fu/timeout 300
                  (fn []
                    (grid/recalculate (assoc (setup-args) :stale-sort? true))
                    (swap! db/deals assoc :loaded true)
                    (deref db/deals))))))

(defn setup
  [closed-atom?]
  (when-not @closed-atom?
    (let [pipeline-id @session/selected-oppo-pipeline
          tenant-default-view-name
          (get-in @session/tenant [:tenant/preferences :dealflow pipeline-id :default-view-name])
          all-named-views (named-views)
          tenant-default-view (->> all-named-views
                                   (cu/filter-by :named-view/name tenant-default-view-name)
                                   (first))]
      (cond tenant-default-view
            (load-view! tenant-default-view)
            (empty? (ls/get-in (ls-path)))
            (load-view! (first (named-views)))
            :else
            (reset! db/view-settings (ls/get-in (ls-path))))
      (swap! db/deals assoc
        :tracker-1 (r/track! entity-updates)
        :tracker-2 (r/track! permission-updates)
        :tracker-3 (r/track! trigger-recalculation))
      (setup-column-state! (ls/get-in (ls-path))))))

(defn toggle-quick-filters!
  []
  (swap! db/deals update :show-quick-filters? not))

(defn switch-mode!
  [current-mode]
  (let [new-mode (if (= current-mode :grid-mode) :board-mode :grid-mode)]
    (swap! db/view-settings assoc :view-mode new-mode)
    (ls/update-in (ls-path) assoc :view-mode new-mode)))

(defn mass-delete!
  []
  (-> (conn/sendp! :oppo/mass-action
                   {:action   :delete-deals
                    :oppo-ids (grid/get-selected-items (setup-args))})
      (p/then (fn [_args]
                (swap! db/deals assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to delete selected deals" e)))))

(defn mass-apply-tags!
  [selected-tag]
  (-> (conn/sendp! :oppo/mass-action
                   {:action   :add-tag-to-all
                    :oppo-ids (grid/get-selected-items (setup-args))
                    :tag-ids  (into [] selected-tag)})
      (p/then (fn [_args]
                (swap! db/deals assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to apply tags to selected deals" e)))))

(defn mass-remove-tags!
  [selected-tags]
  (-> (conn/sendp! :oppo/mass-action
                   {:action   :remove-tags-from-all
                    :oppo-ids (grid/get-selected-items (setup-args))
                    :tag-ids  (into [] selected-tags)})
      (p/then (fn [_args]
                (swap! db/deals assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to remove tags to selected deals" e)))))

(defn open-selected!
  [_]
  (let [oppo-id (-> (grid/get-selected-items (setup-args))
                    (first))]
    (routing/open-entity oppo-id)))

(defn delete-selected-clicked
  [_]
  (modals/open-modal!
   confirmation/modal-key
   {:body          [:div
                    [:p (loc/tr :confirm-delete-selected)]]
    :confirm-text  (loc/tr :confirm-delete-selected-button)
    :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
    :on-confirm    #(mass-delete!)}))

(defn export-finindus-partner-data
  []
  (let [todays-date (session/long->tenant-date (.getTime (js/Date.)))
        cols [:partner :new-partner :source :type-of-partner :website
              :department :new-department :city :country :address
              :dept-website :topic :expertise-domain-tag :expertise-subdomain-tag
              :description-project-objectives :situation-description :situation-date
              :current-status :laboratory :nda :nda-signed-date :nda-start-date
              :nda-end-date :nda-url :arcelor-mittal-contact :contact-name :contact-phone
              :contact-email :contact-position :number-of-phds :technology-maturity
              :assetments-comments :rating]
        selected-item-ids (when-not (= (:selected @db/deals) :all)
                            (some->> (:selected @db/deals)
                                     (map (fn [[k s]]
                                            (when s
                                              k)))))
        sorted-deals (:sorted-kanban-entities @db/deals)
        deals
        (->>
          sorted-deals
          (map
           (fn [deal]
             (let [company (->> deal
                                :oppo/target-asset
                                (get @session/entities))]
               {:db/id (:db/id deal)
                :partner "__NEW PARTNER__"
                :new-partner (:oppo/name deal)
                :source "Finindus"
                :type-of-partner "Start-Up"
                :website (:company/website company)
                :department "__NEW DEPARTMENT__"
                :new-department (:asset/name company)
                :city (:asset/city company)
                :country (some->> (:asset/country company)
                                  (map (fn [cc]
                                         (country/get-label cc)))
                                  (string/join ";"))
                :address ""
                :dept-website ""
                :topic (:asset/description company)
                :expertise-domain-tag (some->> (:company/tag-sector company)
                                               (map (fn [tag-id]
                                                      (entity/display-string
                                                       (get @session/entities tag-id))))
                                               (string/join ";"))
                :expertise-subdomain-tag (some->> (:company/tag-sub-sector company)
                                                  (map (fn [tag-id]
                                                         (entity/display-string
                                                          (get @session/entities tag-id))))
                                                  (string/join ";"))
                :description-project-objectives ""
                :situation-description ""
                :situation-date todays-date
                :current-status "TO BE INITIATED"
                :laboratory ""
                :nda ""
                :nda-signed-date ""
                :nda-start-date ""
                :nda-end-date ""
                :nda-url ""
                :contact-name ""
                :contact-phone ""
                :contact-email ""
                :contact-position ""
                :number-of-phds ""
                :assetments-comments ""
                :rating ""
                :arcelor-mittal-contact (some->> (:oppo/group-business-units deal)
                                                 (map (fn [nv]
                                                        (entity/display-string
                                                         (get @session/entities nv))))
                                                 (string/join ";"))
                :technology-maturity (some->> (:company/technology-maturity company)
                                              (map (fn [nv]
                                                     (entity/display-string
                                                      (get @session/entities nv))))
                                              (string/join ";"))

               }))))]
    (excel/export-entities (loc/tr :export-filename-deals [todays-date])
                           cols
                           (count sorted-deals)
                           nil
                           (or (when (and (coll? selected-item-ids)
                                          (seq selected-item-ids))
                                 (->> deals
                                      (filter (fn [deal]
                                                (some #{(:db/id deal)} selected-item-ids)))
                                      (into [])))
                               deals))))

(defn default-card-mode
  []
  :short-card)

(defn get-card-mode
  []
  (or (:card-mode @db/kanban)
      (default-card-mode)))

(defn expanded?
  [entity-id]
  (let [card-mode (get-card-mode)
        individual (get @db/expanded entity-id)]
    (or (and (= card-mode :short-card)
             individual)
        (and (= card-mode :long-card)
             (not individual)))))

(defn toggle-expand!
  [entity-id]
  (let [expanded? (get @db/expanded entity-id)]
    (if expanded?
      (swap! db/expanded dissoc entity-id)
      (swap! db/expanded assoc entity-id true))))

(defn show-collapse-all?
  []
  (let [card-mode (get-card-mode)
        individual-count (count @db/expanded)
        total-entity-count (count @db/sorted-kanban-entities)]
    (or (and (= card-mode :short-card)
             (> individual-count 0))
        (and (= card-mode :long-card)
             (< individual-count total-entity-count)))))

(defn expand-all!
  []
  (swap! db/kanban assoc :card-mode :long-card)
  (reset! db/expanded {}))

(defn collapse-all!
  []
  (swap! db/kanban assoc :card-mode :short-card)
  (reset! db/expanded {}))

(defn open-card-settings!
  []
  (swap! db/kanban assoc :card-settings? true))

(defn close-card-settings!
  []
  (swap! db/kanban dissoc :card-settings?))
